<template>
  <div class="border rounded p-2 alert-info">
    <p class="text-right mb-0">
      <span style="cursor: pointer;" @click="remove">×</span>
    </p>
    <p>
      Password cannot be the word "password" - can't be your username and it
      can't be less than 5 chars (sorry)
    </p>
    <p>No action taken. Please go back and try again.</p>
    <p></p>
    <form>
      <button type="button" class="btn btn-default" @click="remove">
        back
      </button>
    </form>
    <p></p>
  </div>
</template>

<script>
export default {
  name: "PasswordCheckMessage",
  methods: {
    remove() {
      this.$store.commit("manageSystemUsers/SET_PASSWORD_CHECK", false);
    },
  },
};
</script>

<style scoped>
.alert-info {
  color: #3a87ad;
  background-color: #d9edf7;
  border-color: #bce8f1;
}
.btn-default {
  color: #fff;
  background-color: #aea79f;
  border-color: #aea79f;
}
.btn:focus,
.btn:active {
  outline: 2px solid black !important;
  box-shadow: none !important;
}
.btn:hover {
  color: #fff;
  background-color: #978e83;
  border-color: #92897e;
}
</style>
